import classnames from "classnames";
import { observer } from "mobx-react";
import React, { useState, useEffect } from "react";
import { useStore } from "../../../models";
import { AccelerateTile, PlanPeriod } from "./accelerateTile";
import { EnterpriseTile } from "./enterpriseTile";
import styles from "./upgradePlan.css";
import { UpgradeToAccelerateAdmin } from "./upgradeToAccelerateAdmin";
import { UpgradeToEnterpriseAdmin } from "./upgradeToEnterpriseAdmin";
import { PlanType, UpgradeToPlanAgent } from "./upgradeToPlanAgent";
import { BillingPlan } from "@closerplatform/spinner-openapi";
import { staticConfig } from "@fidget/common/config/static-config";
import { useAgentServices } from "../../../models/agentServices";

interface Props {
  closeModal: () => void;
}

export const UpgradePlan = observer(({ closeModal }: Props) => {
  const { spinnerService } = useAgentServices();
  const [plan, setPlan] = useState<PlanType>(PlanType.ACCELERATE);
  // const [period, setPeriod] = useState<PlanPeriod>(PlanPeriod.MONTH);
  const period = PlanPeriod.MONTH;
  const [billingInfo, setBillingInfo] = useState<BillingPlan>();
  const { uiStore } = useStore();

  useEffect(() => {
    spinnerService.getPlanDetails(staticConfig.newestAccelerate).then((info: BillingPlan) => {
      setBillingInfo(info);
    });
  }, []);

  const onClickOnTile = (p: PlanType) => {
    setPlan(p);
  };

  const renderUpgradeToPlanAdmin = () => {
    switch (plan) {
      case PlanType.ACCELERATE:
        return (
          <UpgradeToAccelerateAdmin price={billingInfo?.price} currency={billingInfo?.currency} />
        );
      case PlanType.ENTERPRISE:
        return <UpgradeToEnterpriseAdmin />;
      default:
        return <></>;
    }
  };

  const renderUpgradeToPlan = () =>
    uiStore.canDisplayAdminComponents() ? (
      renderUpgradeToPlanAdmin()
    ) : (
      <UpgradeToPlanAgent plan={plan} closeModal={closeModal} />
    );

  /*const changePlanPeriod = () => {
    setPeriod(period === PlanPeriod.MONTH ? PlanPeriod.YEAR : PlanPeriod.MONTH);
  };*/

  return (
    <div className={styles.container}>
      <div className={classnames(styles.column, styles["first-column"])}>
        {renderUpgradeToPlan()}
      </div>
      <div className={classnames(styles.column, styles["second-column"])}>
        <AccelerateTile
          handleClick={onClickOnTile}
          isActive={plan === PlanType.ACCELERATE}
          period={period}
          price={billingInfo !== undefined ? billingInfo.price : 49}
          currency={billingInfo !== undefined ? billingInfo.currency : "USD"}
        />
        <EnterpriseTile handleClick={onClickOnTile} isActive={plan === PlanType.ENTERPRISE} />
      </div>
    </div>
  );
});
